import { WrappedError } from './wrapped-error';

/**
 * Error to be emitted for when access to a resource has been denied.
 */
export class UnknownNetworkError extends WrappedError {
  public readonly name: string = 'UnknownNetworkError';
}
